import React, { useState, useEffect } from "react";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import getServices from "../../Services/get-service";
import Constant from "../../Constant";
import { Skeleton } from "@mui/material";
import Note from "../../Assets/images/note.svg";

function ActiveInvestmentsCarousel({ onPropertyClick }) {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getServices.getActiveProperty("", 20, 0)
      .then(res => {
        if (res.data.statusCode === 200) {
          const rawProperties = res.data.data.activeProperties || [];
          const fetchedData = rawProperties.map((p) => ({
            ...p,
            id: p.propertyId,
            image: p.propertyImages?.[0]?.imageUrl,
            title: p.productName,
            location: p.location,
            type: p.investmentType,
            typeColor:
              p.investmentType?.toLowerCase() === "sales"
                ? "bg-[#00BC67] text-white"
                : "bg-[#007BFF] text-white",
            price: `₦ ${Constant.FormatNumber(p.amount)}`,
            returnPercentage: p.profit ? `+${p.profit}%` : null,
          }));
          setProperties(fetchedData);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="my-6">
      <p className="text-[14px] font-[500] text-[#808285] mb-3">
        Active Investments
      </p>

      {/* Carousel Container */}
      <div className="flex gap-4 overflow-x-auto pb-4 hide-scrollbar cursor-pointer">
        {loading ? (
          [1, 2, 3].map((item) => (
            <div
              key={item}
              className="border border-[#E6E6E7] rounded-xl flex-shrink-0 flex overflow-hidden bg-white w-[280px]"
            >
              <Skeleton variant="rectangular" width={120} height={100} />
              <div className="p-3 flex flex-col justify-between w-full">
                <div>
                  <Skeleton variant="text" width="80%" />
                  <Skeleton variant="text" width="60%" />
                </div>
                <div className="flex justify-between items-end w-full">
                  <Skeleton variant="rectangular" width={40} height={16} />
                  <Skeleton variant="text" width={60} />
                </div>
              </div>
            </div>
          ))
        ) : properties.length === 0 ? (
          <div className="w-full bg-white rounded-2xl border border-dashed border-gray-200 p-8 text-center flex flex-col items-center justify-center">
            <img src={Note} alt="Empty" className="w-12 h-12 opacity-50 mb-2" />
            <h3 className="text-gray-700 font-medium text-sm mb-1">
              No active investments
            </h3>
          </div>
        ) : (
          properties.map((inv) => (
            <div
              key={inv.id}
              className="border border-[#E6E6E7] rounded-xl flex-shrink-0 flex overflow-hidden bg-white hover:shadow-sm transition-shadow min-w-[280px]"
              onClick={() => onPropertyClick && onPropertyClick(inv)}
            >
              {/* Image Section */}
              <div className="w-[120px] h-[100px] flex-shrink-0">
                <img
                  src={inv.image}
                  alt={inv.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Details Section */}
              <div className="p-3 flex flex-col justify-between w-full">
                <div className="flex justify-between items-start w-full">
                  <div>
                    <p className="text-[14px] font-bold text-back-color2 mb-1">
                      {inv.title}
                    </p>
                    <p className="text-[#808285] text-[10px] flex items-center mb-1 w-[140px]">
                      <LocationOnOutlinedIcon
                        style={{ fontSize: "12px", marginRight: "2px" }}
                      />
                      {inv.location}
                    </p>
                  </div>
                </div>

                <div className="flex justify-between items-end w-full">
                  {inv.type && (
                    <span
                      className={`text-[10px] px-2 py-0.5 rounded ${inv.typeColor}`}
                    >
                      {inv.type}
                    </span>
                  )}
                  <p className="text-back-color2 text-[14px] font-bold">
                    {inv.price}
                  </p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      <style jsx>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
}
export default ActiveInvestmentsCarousel;
